import React from 'react';
import { Icon } from './Icon.js';
export const IconEnterHome = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M14 13H14.543H3", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M11.5 16.5L15 13L11.5 9.5", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M21 21V8.75L12 2L3 8.75V21H21Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconEnterHome.js.map